import { render } from "./NotesHistoryModal.vue?vue&type=template&id=1590fb1d"
import script from "./NotesHistoryModal.vue?vue&type=script&lang=js"
export * from "./NotesHistoryModal.vue?vue&type=script&lang=js"

import "./NotesHistoryModal.vue?vue&type=style&index=0&id=1590fb1d&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__